import script from "./BreachTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BreachTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__